var map = {
	"./4goverviewcircle.svg": 6753,
	"./5goverview.svg": 4820,
	"./5goverviewcircle.svg": 6328,
	"./availability.dark.svg": 551,
	"./availability.svg": 7341,
	"./ccq.dark.svg": 629,
	"./ccq.svg": 4141,
	"./chart.svg": 7208,
	"./coverage.dark.svg": 752,
	"./coverage.svg": 9380,
	"./download.dark.svg": 8279,
	"./download.svg": 9007,
	"./drilldown.svg": 2855,
	"./ecq.dark.svg": 1621,
	"./ecq.svg": 9223,
	"./extent.dark.svg": 798,
	"./extent.svg": 1382,
	"./games.dark.svg": 668,
	"./games.svg": 3839,
	"./home.svg": 2520,
	"./latency.dark.svg": 5476,
	"./latency.svg": 7495,
	"./upload.dark.svg": 7689,
	"./upload.svg": 377,
	"./user-guide-ci.svg": 1364,
	"./user-guide.svg": 1690,
	"./video.dark.svg": 3275,
	"./video.svg": 3340,
	"./voice.dark.svg": 315,
	"./voice.svg": 9351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;